function throttle(callback: Function, limit: number) {
    let wait = false;
    return function() {
        if (!wait) {
            // @ts-ignore-next-line
            callback.call();
            wait = true;
            setTimeout(() => {
                wait = false;
            }, limit);
        }
    };
}

function debounce(callback: Function, wait: number) {
    let timeout: null | ReturnType<typeof setTimeout> = null;
    let callbackArgs: null | Array<any> = null;

    // @ts-ignore-next-line
    const later = () => callback.apply(this, callbackArgs);

    return function(...args: any) {
        callbackArgs = args;
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(later, wait);
    };
}

function debounceImmediate(callback: Function, wait: number, ...args: any) {
    let isCooldown = false;
    return () => {
        if (isCooldown) return;
        // @ts-ignore-next-line
        callback.apply(this, ...args);
        isCooldown = true;
        setTimeout(() => { isCooldown = false; }, wait);
    };
}

export {
    throttle,
    debounce,
    debounceImmediate,
};
